<template>
  <div>
    <!-- Filtros Card -->
    <v-card ref="filterCard" class="pa-4 mb-4 filter-card elevation-0">
      <v-row dense align="center">
        <v-col cols="12" md="5" class="d-flex align-center">
          <div class="d-flex flex-wrap align-center gap-3 w-100">
            <div class="filter-pill">
              <v-icon small class="mr-1 primary--text">mdi-domain</v-icon>
              <span class="pill-label">Unidad:</span>
              <span class="pill-value text-truncate" style="max-width: 180px;" :title="nombreUnidadNegocioSeleccionada">
                {{ nombreUnidadNegocioSeleccionada || 'No seleccionada' }}
              </span>
            </div>
            <div class="filter-pill">
              <v-icon small class="mr-1 primary--text">mdi-calendar-range</v-icon>
              <span class="pill-label">Periodo:</span>
              <span class="pill-value">{{ fechaInicio || '-' }} - {{ fechaFin || '-' }}</span>
            </div>
          </div>
        </v-col>

        <v-col cols="12" md="7" class="d-flex justify-md-end justify-start flex-wrap align-center gap-2 mt-2 mt-md-0">
          <!-- Vista Toggle -->
          <v-btn-toggle v-model="vista" mandatory class="custom-toggle elevation-0 mr-1">
            <v-btn value="tabla" class="toggle-btn px-3">
              <v-icon left small>mdi-table-large</v-icon>
              Vista Tabla
            </v-btn>
            <v-btn value="estadistico" class="toggle-btn px-3">
              <v-icon left small>mdi-chart-box-outline</v-icon>
              Reporte Estadístico
            </v-btn>
          </v-btn-toggle>

          <v-btn
            depressed
            outlined
            color="primary"
            class="rounded-lg action-btn"
            title="Filtros"
            @click="abrirDialogoFiltros"
          >
            <v-icon color="primary">mdi-filter-variant</v-icon>
          </v-btn>

          <v-btn
            depressed
            outlined
            color="primary"
            class="rounded-lg action-btn"
            :title="textoBotonSedes"
            :disabled="items.length === 0"
            @click="mostrarDialogoSedes = true"
          >
            <v-badge
              :content="sedesSeleccionadas.length"
              :value="sedesSeleccionadas.length > 0"
              color="primary"
              overlap>
              <v-icon color="primary">mdi-office-building-marker</v-icon>
            </v-badge>
          </v-btn>

          <v-btn
            depressed
            outlined
            color="success"
            class="rounded-lg action-btn"
            title="Exportar Excel"
            :loading="descargandoExcel"
            :disabled="!unidadNegocioId"
            @click="exportarExcel"
          >
            <v-icon color="success">mdi-file-excel-outline</v-icon>
          </v-btn>

          <v-btn
            depressed
            color="primary"
            class="rounded-lg action-btn"
            title="Recargar"
            :loading="cargando"
            :disabled="!unidadNegocioId"
            @click="listarRestableciendoPagina"
          >
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-card>

    <!-- Dialog de Filtros -->
    <v-dialog v-model="mostrarDialogoFiltros" max-width="600" overlay-color="#0f172a" overlay-opacity="0.6" content-class="custom-dialog">
      <v-card class="rounded-xl overflow-hidden filter-dialog-card">
        <v-card-title class="dialog-header px-6 py-5 d-flex align-center justify-space-between border-bottom">
          <div class="d-flex align-center">
            <div class="filter-header-icon mr-3">
              <v-icon color="primary">mdi-filter-variant</v-icon>
            </div>
            <div>
              <div class="text-h6 font-weight-bold slate-900--text" style="line-height: 1.2;">Configurar Filtros</div>
              <div class="text-caption grey--text text--darken-1 mt-0.5">Establezca los criterios para filtrar los pagos de docentes por empresa</div>
            </div>
          </div>
          <v-btn icon color="grey darken-1" @click="mostrarDialogoFiltros = false" small class="close-btn">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="px-6 py-4 dialog-body">
          <v-row dense class="mb-2">
            <v-col cols="12" class="mb-2">
              <span class="input-label">Unidad de negocio</span>
              <v-autocomplete
                v-model="unidadNegocioIdDialogo"
                :items="unidadesNegocio"
                item-text="nombre"
                item-value="id"
                placeholder="Seleccione la unidad de negocio..."
                outlined
                dense
                hide-details
                prepend-inner-icon="mdi-domain"
                :loading="cargandoUnidadesNegocio"
                class="rounded-lg custom-input mt-1" />
            </v-col>
          </v-row>

          <v-row dense>
            <v-col cols="12" sm="6" class="mb-2 pr-sm-2">
              <span class="input-label">Fecha de inicio</span>
              <v-menu
                ref="menuFechaInicioDialogo"
                v-model="menuFechaInicioDialogo"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="fechaInicioDialogo"
                    placeholder="Seleccione fecha..."
                    readonly
                    outlined
                    dense
                    hide-details
                    prepend-inner-icon="mdi-calendar"
                    v-bind="attrs"
                    v-on="on"
                    class="rounded-lg custom-input mt-1" />
                </template>
                <v-date-picker
                  v-model="fechaInicioDialogo"
                  locale="es-ES"
                  @input="menuFechaInicioDialogo = false" />
              </v-menu>
            </v-col>

            <v-col cols="12" sm="6" class="mb-2 pl-sm-2">
              <span class="input-label">Fecha de fin</span>
              <v-menu
                ref="menuFechaFinDialogo"
                v-model="menuFechaFinDialogo"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="fechaFinDialogo"
                    placeholder="Seleccione fecha..."
                    readonly
                    outlined
                    dense
                    hide-details
                    prepend-inner-icon="mdi-calendar"
                    v-bind="attrs"
                    v-on="on"
                    class="rounded-lg custom-input mt-1" />
                </template>
                <v-date-picker
                  v-model="fechaFinDialogo"
                  locale="es-ES"
                  @input="menuFechaFinDialogo = false" />
              </v-menu>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="px-6 py-4 bg-light d-flex justify-end gap-2">
          <v-btn
            depressed
            outlined
            class="rounded-lg action-btn cancel-btn"
            @click="mostrarDialogoFiltros = false"
          >
            Cancelar
          </v-btn>
          <v-btn
            depressed
            color="primary"
            class="rounded-lg action-btn apply-btn px-6"
            :disabled="!unidadNegocioIdDialogo || !fechaInicioDialogo || !fechaFinDialogo"
            @click="aplicarFiltrosDialogo"
          >
            <v-icon left small>mdi-check</v-icon>
            Aplicar Filtros
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>



    <v-progress-linear v-if="cargando" indeterminate color="primary" class="mb-4 rounded" height="4" />

    <!-- Contenido Principal -->
    <template v-if="vista === 'tabla'">
      <div v-if="!cargando && items.length === 0" class="empty-state-card py-12 px-6 text-center">
        <v-icon size="64" color="grey lighten-1" class="mb-3">mdi-database-alert-outline</v-icon>
        <h3 class="text-h6 font-weight-medium grey--text text--darken-3 mb-1">Sin información para mostrar</h3>
        <p class="body-2 grey--text text--darken-1 max-w-md mx-auto mb-4">
          No se encontraron registros de control de pago para la unidad de negocio y rango de fechas seleccionados.
        </p>
        <v-btn depressed color="primary" class="rounded-lg px-6" :disabled="!unidadNegocioId" @click="listarRestableciendoPagina">
          <v-icon left>mdi-refresh</v-icon>
          Reintentar búsqueda
        </v-btn>
      </div>

      <template v-else>
        <div
          ref="contenidoInferior"
          class="contenido-inferior"
          :style="alturaContenidoPx ? { height: alturaContenidoPx + 'px' } : {}">
          <div class="grid-card-container">
            <ag-grid-vue
              :gridOptions="gridOptions"
              class="ag-theme-balham ag-grid-control-pago-docente-empresa"
              :columnDefs="columnDefs"
              :defaultColDef="defaultColDef"
              @grid-ready="onGridReady"
              :rowData="itemsFiltrados"
              :pinnedBottomRowData="filasTotal"
              colResizeDefault="shift"
              :animateRows="false"
              :floatingFilter="true"
              :pagination="false"
              @first-data-rendered="onFirstDataRendered"
              :alwaysShowVerticalScroll="true"
              :suppressPaginationPanel="true" />
          </div>

          <div class="d-flex align-center justify-space-between flex-wrap mt-4 px-1 gap-2">
            <div class="d-flex align-center">
              <span class="caption grey--text text--darken-1 font-weight-medium mr-4" v-if="metadatos">
                Página {{ pagina }} de {{ metadatos.totalPaginas }}
              </span>
              <v-select
                :items="[10, 25, 50, 75, 100, 150]"
                label="Items por página"
                v-model="itemsPorPagina"
                outlined
                dense
                hide-details
                style="max-width: 150px"
                :disabled="items.length === 0"
                @change="listarRestableciendoPagina"
                class="rounded-lg custom-input" />
            </div>

            <v-pagination
              v-model="pagina"
              :length="metadatos?.totalPaginas || 0"
              :total-visible="7"
              @input="listar"
              color="primary"
              class="custom-pagination" />
          </div>
        </div>
      </template>
    </template>

    <template v-else>
      <div v-if="!cargando && items.length === 0" class="empty-state-card py-12 px-6 text-center">
        <v-icon size="64" color="grey lighten-1" class="mb-3">mdi-database-alert-outline</v-icon>
        <h3 class="text-h6 font-weight-medium grey--text text--darken-3 mb-1">Sin información para mostrar</h3>
        <p class="body-2 grey--text text--darken-1 max-w-md mx-auto mb-4">
          No se encontraron registros de control de pago para la unidad de negocio y rango de fechas seleccionados.
        </p>
        <v-btn depressed color="primary" class="rounded-lg px-6" :disabled="!unidadNegocioId" @click="listarRestableciendoPagina">
          <v-icon left>mdi-refresh</v-icon>
          Reintentar búsqueda
        </v-btn>
      </div>

      <template v-else>
        <!-- Resumen Tarjetas -->
        <v-row dense class="mb-4">
          <v-col cols="6" sm="4" md="2" v-for="tarjeta in tarjetasResumen" :key="tarjeta.etiqueta">
            <v-card outlined class="pa-4 stat-card d-flex align-center h-100">
              <div class="stat-icon-wrapper mr-3" :class="tarjeta.bgColor">
                <v-icon :color="tarjeta.color" size="22">{{ tarjeta.icon }}</v-icon>
              </div>
              <div class="text-left">
                <div class="text-h5 font-weight-bold loyalty-num" :class="`${tarjeta.color}--text`">
                  {{ tarjeta.valor }}
                </div>
                <div class="caption font-weight-semibold text-secondary-custom">{{ tarjeta.etiqueta }}</div>
              </div>
            </v-card>
          </v-col>
        </v-row>

        <!-- Gráficos -->
        <v-row dense>
          <v-col cols="12" md="7">
            <v-card outlined class="pa-4 chart-card">
              <div class="d-flex align-center mb-4">
                <v-icon color="primary" class="mr-2">mdi-chart-bar</v-icon>
                <div class="subtitle-1 font-weight-bold dark-text">Docentes por Sede / Programa</div>
              </div>
              <v-divider class="mb-4"></v-divider>
              <div class="chart-container">
                <HorizontalBarChart :chart-data="datosGraficoBarras" :chart-options="opcionesGraficoBarras" />
              </div>
            </v-card>
          </v-col>

          <v-col cols="12" md="5">
            <v-card outlined class="pa-4 chart-card">
              <div class="d-flex align-center mb-4">
                <v-icon color="primary" class="mr-2">mdi-chart-bar</v-icon>
                <div class="subtitle-1 font-weight-bold dark-text">Cumple Requisitos, Pago Pendiente</div>
              </div>
              <v-divider class="mb-4"></v-divider>
              <div class="chart-container">
                <HorizontalBarChart :chart-data="datosGraficoRankingSedes" :chart-options="opcionesGraficoRankingSedes" />
              </div>
            </v-card>
          </v-col>
        </v-row>
      </template>
    </template>

    <!-- Dialog de Sedes -->
    <v-dialog v-model="mostrarDialogoSedes" max-width="600" scrollable overlay-color="#0f172a" overlay-opacity="0.6" content-class="custom-dialog">
      <v-card class="rounded-xl overflow-hidden filter-dialog-card">
        <v-card-title class="dialog-header px-6 py-5 d-flex align-center justify-space-between border-bottom">
          <div class="d-flex align-center">
            <div class="filter-header-icon mr-3">
              <v-icon color="primary">mdi-office-building-marker</v-icon>
            </div>
            <div>
              <div class="text-h6 font-weight-bold slate-900--text" style="line-height: 1.2;">Seleccionar Sedes</div>
              <div class="text-caption grey--text text--darken-1 mt-0.5">Seleccione las sedes para filtrar la información</div>
            </div>
          </div>
          <v-btn icon color="grey darken-1" @click="mostrarDialogoSedes = false" small class="close-btn">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <div class="px-6 pt-4 pb-3 bg-light border-bottom">
          <v-text-field
            v-model="busquedaSede"
            placeholder="Buscar sede..."
            prepend-inner-icon="mdi-magnify"
            outlined
            dense
            clearable
            hide-details
            class="rounded-lg custom-input mb-3" />

          <div class="d-flex justify-space-between align-center">
            <span class="caption font-weight-medium grey--text text--darken-1">
              {{ sedesSeleccionadas.length }} de {{ sedesDisponibles.length }} seleccionadas
            </span>
            <div class="d-flex gap-2">
              <v-btn
                x-small
                text
                color="primary"
                class="font-weight-semibold rounded-md"
                :disabled="sedesSeleccionadas.length === sedesDisponibles.length"
                @click="sedesSeleccionadas = [...sedesDisponibles]">
                <v-icon left x-small>mdi-checkbox-multiple-marked</v-icon>
                Todas
              </v-btn>

              <v-btn
                x-small
                text
                color="error"
                class="font-weight-semibold rounded-md"
                :disabled="sedesSeleccionadas.length === 0"
                @click="sedesSeleccionadas = []">
                <v-icon left x-small>mdi-checkbox-multiple-blank-outline</v-icon>
                Ninguna
              </v-btn>
            </div>
          </div>
        </div>

        <v-card-text class="px-6 py-4" style="max-height: 400px">
          <div v-if="sedesDisponiblesFiltradas.length === 0" class="text-center py-6">
            <v-icon size="40" color="grey lighten-1" class="mb-2">mdi-office-building-outline</v-icon>
            <div class="body-2 grey--text">No se encontraron sedes con ese criterio.</div>
          </div>

          <v-row v-else dense>
            <v-col cols="12" sm="6" v-for="sede in sedesDisponiblesFiltradas" :key="sede" class="py-1">
              <div
                :class="['sede-item-wrapper', sedesSeleccionadas.includes(sede) ? 'sede-item-selected' : '']"
                @click="toggleSede(sede)"
              >
                <v-checkbox
                  v-model="sedesSeleccionadas"
                  :label="sede"
                  :value="sede"
                  dense
                  hide-details
                  color="primary"
                  class="sede-checkbox"
                  @click.native.stop />
              </div>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="px-6 py-4 bg-light d-flex justify-end">
          <v-btn color="primary" depressed class="rounded-lg action-btn apply-btn px-6" @click="mostrarDialogoSedes = false">
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import AgGridMixin from '@/views/pagos/mixins/ag-grid.mixin';
import ReporteDocenteService from '../services/reporte-docente.service';
import HorizontalBarChart from './charts/HorizontalBarChart.vue';

const COLORES_PALETA = ['#1976D2', '#43A047', '#FB8C00', '#E53935', '#8E24AA', '#00897B'];

export default {
  name: 'ControlPagoDocentePorEmpresaTab',
  components: {
    HorizontalBarChart,
  },
  mixins: [AgGridMixin],
  data() {
    return {
      vista: 'tabla',
      cargando: false,
      alturaContenidoPx: null,
      descargandoExcel: false,
      cargandoUnidadesNegocio: false,
      unidadesNegocio: [],
      unidadNegocioId: null,
      fechaInicio: null,
      fechaFin: null,
      fechaInicioDialogo: null,
      fechaFinDialogo: null,
      menuFechaInicioDialogo: false,
      menuFechaFinDialogo: false,
      pagina: 1,
      itemsPorPagina: 150,
      metadatos: null,
      items: [],
      sedesSeleccionadas: [],
      mostrarDialogoSedes: false,
      busquedaSede: '',
      mostrarDialogoFiltros: false,
      unidadNegocioIdDialogo: null,
      columnDefs: [
        { headerName: 'Sede', field: 'sede', minWidth: 200, flex: 1 },
        { headerName: 'Programa', field: 'programa', minWidth: 110 },
        { headerName: 'Módulos', field: 'modulos', minWidth: 110 },
        { headerName: 'Docentes Pagados', field: 'docentes_pagados', minWidth: 160 },
        { headerName: 'Docentes Pendientes', field: 'docentes_pendientes', minWidth: 170 },
        { headerName: 'Cumple Requisitos', field: 'docentes_cumple_requisitos', minWidth: 170 },
        { headerName: 'No Cumple', field: 'docentes_no_cumple', minWidth: 130 },
        { headerName: 'Cumple Requisitos, Pago Pendiente', field: 'docentes_cumple_pendiente_pago', minWidth: 170 },
        { headerName: 'Total Docentes', field: 'total_docente', minWidth: 150 },
      ],
      opcionesGraficoBarras: {
        responsive: true,
        maintainAspectRatio: false,
        legend: { position: 'bottom' },
        scales: {
          xAxes: [{ stacked: true, ticks: { beginAtZero: true, precision: 0 } }],
          yAxes: [{ stacked: true, ticks: { autoSkip: false } }],
        },
      },
      opcionesGraficoRankingSedes: {
        responsive: true,
        maintainAspectRatio: false,
        legend: { display: false },
        scales: {
          xAxes: [{ ticks: { beginAtZero: true, precision: 0 } }],
          yAxes: [{ ticks: { autoSkip: false } }],
        },
      },
    };
  },
  computed: {
    nombreUnidadNegocioSeleccionada() {
      return this.unidadesNegocio.find((unidad) => unidad.id == this.unidadNegocioId)?.nombre || '';
    },
    sedesDisponibles() {
      return [...new Set(this.items.map((fila) => fila.sede))];
    },
    sedesDisponiblesFiltradas() {
      const busqueda = (this.busquedaSede || '').trim().toLowerCase();

      if (!busqueda) {
        return this.sedesDisponibles;
      }

      return this.sedesDisponibles.filter((sede) => sede.toLowerCase().includes(busqueda));
    },
    textoBotonSedes() {
      if (this.sedesSeleccionadas.length === 0) {
        return 'Ninguna sede seleccionada';
      }

      if (this.sedesSeleccionadas.length === this.sedesDisponibles.length) {
        return 'Todas las sedes';
      }

      return `${this.sedesSeleccionadas.length} sede(s) seleccionada(s)`;
    },
    itemsFiltrados() {
      if (this.sedesSeleccionadas.length === 0) {
        return [];
      }

      return this.items.filter((fila) => this.sedesSeleccionadas.includes(fila.sede));
    },
    filasTotal() {
      if (!this.itemsFiltrados.length) {
        return [];
      }

      const sumar = (campo) => this.itemsFiltrados.reduce((acumulado, fila) => acumulado + (fila[campo] || 0), 0);

      return [
        {
          sede: 'TOTAL',
          programa: sumar('programa'),
          modulos: sumar('modulos'),
          docentes_pagados: sumar('docentes_pagados'),
          docentes_pendientes: sumar('docentes_pendientes'),
          docentes_cumple_requisitos: sumar('docentes_cumple_requisitos'),
          docentes_no_cumple: sumar('docentes_no_cumple'),
          docentes_cumple_pendiente_pago: sumar('docentes_cumple_pendiente_pago'),
          total_docente: sumar('total_docente'),
        },
      ];
    },
    tarjetasResumen() {
      const sumar = (campo) => this.itemsFiltrados.reduce((acumulado, fila) => acumulado + (fila[campo] || 0), 0);

      return [
        {
          etiqueta: 'Total Docentes',
          valor: sumar('total_docente'),
          color: 'primary',
          icon: 'mdi-account-group',
          bgColor: 'bg-light-primary',
        },
        {
          etiqueta: 'Pagados',
          valor: sumar('docentes_pagados'),
          color: 'success',
          icon: 'mdi-cash-check',
          bgColor: 'bg-light-success',
        },
        {
          etiqueta: 'Pendientes',
          valor: sumar('docentes_pendientes'),
          color: 'orange',
          icon: 'mdi-cash-minus',
          bgColor: 'bg-light-warning',
        },
        {
          etiqueta: 'Cumple Requisitos',
          valor: sumar('docentes_cumple_requisitos'),
          color: 'info',
          icon: 'mdi-checkbox-marked-circle-outline',
          bgColor: 'bg-light-info',
        },
        {
          etiqueta: 'No Cumple',
          valor: sumar('docentes_no_cumple'),
          color: 'error',
          icon: 'mdi-alert-circle-outline',
          bgColor: 'bg-light-error',
        },
        {
          etiqueta: 'Cumple Requisitos, Pago Pendiente',
          valor: sumar('docentes_cumple_pendiente_pago'),
          color: 'purple',
          icon: 'mdi-account-cash-outline',
          bgColor: 'bg-light-purple',
        },
      ];
    },
    datosGraficoBarras() {
      const etiquetas = this.itemsFiltrados.map((fila) => fila.sede);

      const construirDataset = (campo, etiqueta, color) => ({
        label: etiqueta,
        backgroundColor: color,
        data: this.itemsFiltrados.map((fila) => fila[campo] || 0),
      });

      return {
        labels: etiquetas,
        datasets: [
          construirDataset('docentes_pagados', 'Pagados', COLORES_PALETA[1]),
          construirDataset('docentes_pendientes', 'Pendientes', COLORES_PALETA[2]),
          construirDataset('docentes_no_cumple', 'No Cumple', COLORES_PALETA[3]),
        ],
      };
    },
    datosGraficoRankingSedes() {
      const totalesPorSede = this.sedesSeleccionadas
        .map((sede) => ({
          sede,
          total: this.itemsFiltrados
            .filter((fila) => fila.sede === sede)
            .reduce((acumulado, fila) => acumulado + (fila.docentes_cumple_pendiente_pago || 0), 0),
        }))
        .sort((a, b) => b.total - a.total);

      return {
        labels: totalesPorSede.map((fila) => fila.sede),
        datasets: [
          {
            label: 'Cumple Requisitos, Pago Pendiente',
            backgroundColor: COLORES_PALETA[4],
            data: totalesPorSede.map((fila) => fila.total),
          },
        ],
      };
    },
  },
  watch: {
    items() {
      this.sedesSeleccionadas = [...this.sedesDisponibles];
      this.actualizarAlturaTabla();
    },
    mostrarDialogoSedes(mostrado) {
      if (!mostrado) {
        this.busquedaSede = '';
      }
    },
    cargando() {
      this.actualizarAlturaTabla();
    },
    vista() {
      this.actualizarAlturaTabla();
    },
  },
  async created() {
    const anioActual = new Date().getFullYear();
    this.fechaInicio = `${anioActual}-01-01`;
    this.fechaFin = `${anioActual}-12-31`;

    await this.obtenerUnidadesNegocio();

    this.unidadNegocioId = this.unidadesNegocio[0]?.id ?? null;

    if (this.unidadNegocioId) {
      this.listarRestableciendoPagina();
    }
  },
  mounted() {
    this.actualizarAlturaTabla();
    window.addEventListener('resize', this.actualizarAlturaTabla);
    if (window.ResizeObserver && this.$refs.filterCard) {
      this.observadorFilterCard = new ResizeObserver(() => this.actualizarAlturaTabla());
      this.observadorFilterCard.observe(this.$refs.filterCard.$el || this.$refs.filterCard);
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.actualizarAlturaTabla);
    if (this.observadorFilterCard) {
      this.observadorFilterCard.disconnect();
    }
  },
  methods: {
    actualizarAlturaTabla() {
      this.$nextTick(() => {
        const contenedor = this.$refs.contenidoInferior;
        if (!contenedor) return;

        // Se mide la posición real del contenedor (ya refleja el alto del encabezado
        // de filtros y de la barra de progreso, sin necesidad de sumarlos a mano).
        const top = contenedor.getBoundingClientRect().top;
        const margenInferiorPagina = 24;
        const disponible = window.innerHeight - top - margenInferiorPagina;
        this.alturaContenidoPx = Math.max(disponible, 280);
      });
    },
    toggleSede(sede) {
      const index = this.sedesSeleccionadas.indexOf(sede);
      if (index > -1) {
        this.sedesSeleccionadas.splice(index, 1);
      } else {
        this.sedesSeleccionadas.push(sede);
      }
    },
    abrirDialogoFiltros() {
      this.unidadNegocioIdDialogo = this.unidadNegocioId;
      this.fechaInicioDialogo = this.fechaInicio;
      this.fechaFinDialogo = this.fechaFin;
      this.mostrarDialogoFiltros = true;
    },
    aplicarFiltrosDialogo() {
      if (this.fechaInicioDialogo > this.fechaFinDialogo) {
        this.$notify({
          group: 'notifications',
          title: 'Error de Validación',
          text: 'La Fecha de inicio no puede ser mayor a la Fecha de fin',
          type: 'warning',
        });
        return;
      }
      this.unidadNegocioId = this.unidadNegocioIdDialogo;
      this.fechaInicio = this.fechaInicioDialogo;
      this.fechaFin = this.fechaFinDialogo;
      this.mostrarDialogoFiltros = false;
      this.listarRestableciendoPagina();
    },
    async obtenerUnidadesNegocio() {
      this.cargandoUnidadesNegocio = true;

      try {
        const { data } = await ReporteDocenteService.getUnidadSede();
        const filas = data || [];

        this.unidadesNegocio = filas.map((fila) => fila.empresa);
      } catch (error) {
        this.unidadesNegocio = [];
      } finally {
        this.cargandoUnidadesNegocio = false;
      }
    },
    listarRestableciendoPagina() {
      if (!this.unidadNegocioId) {
        return;
      }

      this.pagina = 1;
      this.listar();
    },
    async listar() {
      if (!this.unidadNegocioId) {
        return;
      }

      this.cargando = true;

      try {
        const { data } = await ReporteDocenteService.controlPagoDocentePorEmpresa({
          unidad_negocio_id: this.unidadNegocioId,
          pagina: this.pagina,
          itemsPorPagina: this.itemsPorPagina,
          fecha_inicio: this.fechaInicio || undefined,
          fecha_fin: this.fechaFin || undefined,
        });

        this.items = data?.data || [];
        this.metadatos = data?.paginacion || null;
      } catch (error) {
        this.items = [];
        this.metadatos = null;
        this.$notify({
          group: 'notifications',
          title: 'Error',
          text: error?.response?.data?.mensaje || 'No se pudo obtener el control de pago docente por empresa',
          type: 'error',
        });
      } finally {
        this.cargando = false;
      }
    },
    async exportarExcel() {
      if (!this.unidadNegocioId) {
        return;
      }

      this.descargandoExcel = true;

      try {
        const response = await ReporteDocenteService.controlPagoDocentePorEmpresaExcel({
          unidad_negocio_id: this.unidadNegocioId,
          unidad_negocio_nombre: this.nombreUnidadNegocioSeleccionada || undefined,
          fecha_inicio: this.fechaInicio || undefined,
          fecha_fin: this.fechaFin || undefined,
        });

        const blob = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const url = URL.createObjectURL(blob);
        const enlace = document.createElement('a');

        enlace.href = url;
        enlace.download = this.obtenerNombreArchivoExcel(response) || 'control-pago-docente-por-empresa.xlsx';
        document.body.appendChild(enlace);
        enlace.click();
        document.body.removeChild(enlace);
        URL.revokeObjectURL(url);

        this.$notify({
          group: 'notifications',
          title: 'Descarga Exitosa',
          text: 'El archivo Excel se ha descargado correctamente.',
          type: 'success',
        });
      } catch (error) {
        this.$notify({
          group: 'notifications',
          title: 'Error',
          text: 'No se pudo descargar el archivo Excel.',
          type: 'error',
        });
      } finally {
        this.descargandoExcel = false;
      }
    },
    obtenerNombreArchivoExcel(response) {
      const contentDisposition = response.headers['content-disposition'];

      if (!contentDisposition) {
        return null;
      }

      const coincidencia = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);

      return coincidencia && coincidencia[1] ? coincidencia[1].replace(/['"]/g, '') : null;
    },
  },
};
</script>

<style>
@import '~ag-grid-community/dist/styles/ag-grid.css';
@import '~ag-grid-community/dist/styles/ag-theme-balham.css';

.ag-grid-control-pago-docente-empresa {
  height: 100%;
}
</style>

<style scoped>
.chart-container {
  position: relative;
  height: 320px;
}

/* Filter Card Styling */
.filter-card {
  border-radius: 12px !important;
  border: 1px solid #e2e8f0 !important;
  background-color: #ffffff !important;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.05) !important;
}

.gap-2 {
  gap: 8px;
}

.gap-3 {
  gap: 12px;
}

.filter-pill {
  display: inline-flex;
  align-items: center;
  background-color: #f1f5f9;
  border: 1px solid #e2e8f0;
  border-radius: 9999px;
  padding: 6px 14px;
  font-size: 0.825rem;
  color: #334155;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.02);
}

.pill-label {
  font-weight: 500;
  color: #64748b;
  margin-right: 4px;
}

.pill-value {
  font-weight: 600;
  color: #1e293b;
}

.action-btn {
  text-transform: none !important;
  font-weight: 500 !important;
  letter-spacing: 0.2px !important;
  height: 38px !important;
}

/* Toggle Styles */
.custom-toggle {
  background-color: #f1f5f9 !important;
  border-radius: 10px !important;
  padding: 4px !important;
  border: 1px solid #e2e8f0 !important;
  display: inline-flex;
}

.custom-toggle .v-btn {
  border: none !important;
  background-color: transparent !important;
  border-radius: 8px !important;
  text-transform: none !important;
  font-weight: 500 !important;
  font-size: 0.85rem !important;
  letter-spacing: 0.1px !important;
  height: 36px !important;
  color: #64748b !important;
}

.custom-toggle .v-btn--active {
  background-color: #ffffff !important;
  color: #1565c0 !important;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03) !important;
}

/* Dialog Styles */
.custom-dialog {
  border-radius: 16px !important;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25) !important;
  overflow: hidden !important;
}

.filter-dialog-card {
  background: #ffffff !important;
  border-radius: 16px !important;
}

.filter-dialog-card .dialog-header {
  background: #ffffff !important;
  border-bottom: 1px solid #f1f5f9 !important;
}

.dialog-header {
  background: linear-gradient(135deg, #1565c0 0%, #1e40af 100%) !important;
}

.filter-header-icon {
  background: #eff6ff;
  border-radius: 10px;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #dbeafe;
}

.dialog-body {
  background: #ffffff !important;
}

.dialog-section-header {
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #64748b;
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  padding-bottom: 6px;
  border-bottom: 1px solid #f1f5f9;
}

.input-label {
  font-size: 0.75rem;
  font-weight: 600;
  color: #475569;
  display: inline-block;
  margin-bottom: 6px;
}

.custom-input ::v-deep .v-input__slot {
  background-color: #f8fafc !important;
  border: 1px solid #cbd5e1 !important;
  border-radius: 8px !important;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: none !important;
  min-height: 40px !important;
}

.custom-input ::v-deep .v-input__slot:hover {
  background-color: #f1f5f9 !important;
  border-color: #94a3b8 !important;
}

.custom-input ::v-deep .v-input__slot:focus-within {
  background-color: #ffffff !important;
  border-color: #2563eb !important;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.15) !important;
}

.custom-input.v-input--is-disabled ::v-deep .v-input__slot {
  background-color: #f1f5f9 !important;
  border-color: #e2e8f0 !important;
  cursor: not-allowed;
}

.custom-input.v-input--is-disabled ::v-deep input {
  color: #94a3b8 !important;
}

.custom-input ::v-deep fieldset {
  border: none !important;
}

.custom-input ::v-deep .v-input__prepend-inner {
  margin-top: 8px !important;
}

.custom-input ::v-deep .v-input__append-inner {
  margin-top: 8px !important;
}

.custom-input ::v-deep .v-icon {
  color: #64748b !important;
  font-size: 20px !important;
}

.custom-input ::v-deep .v-select__selection {
  color: #1e293b !important;
  font-size: 0.875rem !important;
  font-weight: 500 !important;
}

.custom-input ::v-deep input {
  color: #1e293b !important;
  font-size: 0.875rem !important;
  font-weight: 500 !important;
}

.cancel-btn {
  border: 1px solid #cbd5e1 !important;
  color: #475569 !important;
  background-color: #ffffff !important;
}

.cancel-btn:hover {
  background-color: #f8fafc !important;
  color: #1e293b !important;
}

.apply-btn {
  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%) !important;
  color: #ffffff !important;
  box-shadow: 0 4px 6px -1px rgba(37, 99, 235, 0.2), 0 2px 4px -1px rgba(37, 99, 235, 0.1) !important;
  transition: all 0.2s ease !important;
}

.apply-btn:hover {
  box-shadow: 0 6px 8px -1px rgba(37, 99, 235, 0.25), 0 3px 6px -1px rgba(37, 99, 235, 0.15) !important;
  transform: translateY(-1px);
}

.apply-btn:active {
  transform: translateY(0);
}

.apply-btn.v-btn--disabled {
  background: #e2e8f0 !important;
  color: #94a3b8 !important;
  box-shadow: none !important;
  border-color: #e2e8f0 !important;
}

.close-btn {
  transition: transform 0.2s ease;
}

.close-btn:hover {
  transform: rotate(90deg);
}

.slate-900--text {
  color: #0f172a !important;
}

.bg-light {
  background-color: #f8fafc;
}

.border-bottom {
  border-bottom: 1px solid #e2e8f0;
}

.rounded-md {
  border-radius: 6px !important;
}

.sede-item-wrapper {
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 8px 14px;
  display: flex;
  align-items: center;
  background-color: #ffffff;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;
  user-select: none;
}

.sede-item-wrapper:hover {
  background-color: #f8fafc;
  border-color: #cbd5e1;
}

.sede-item-selected {
  background-color: #eff6ff;
  border-color: #3b82f6;
  box-shadow: 0 1px 2px 0 rgba(59, 130, 246, 0.05);
}

.sede-checkbox {
  margin-top: 0 !important;
  padding-top: 0 !important;
  width: 100%;
}

.sede-checkbox ::v-deep .v-messages {
  display: none;
}

.sede-checkbox ::v-deep label {
  font-size: 0.875rem !important;
  color: #334155 !important;
  font-weight: 500 !important;
  cursor: pointer;
}

.sede-item-selected .sede-checkbox ::v-deep label {
  color: #1d4ed8 !important;
  font-weight: 600 !important;
}

/* Stat Cards */
.stat-card {
  border-radius: 12px !important;
  border: 1px solid #e2e8f0 !important;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.05) !important;
  transition: transform 0.2s, box-shadow 0.2s;
  background-color: #ffffff;
}

.stat-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.08), 0 2px 4px -1px rgba(0, 0, 0, 0.04) !important;
}

.stat-icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 10px;
  flex-shrink: 0;
}

.bg-light-primary { background-color: rgba(21, 101, 192, 0.08) !important; }
.bg-light-success { background-color: rgba(76, 175, 80, 0.08) !important; }
.bg-light-warning { background-color: rgba(251, 140, 0, 0.08) !important; }
.bg-light-info { background-color: rgba(33, 150, 243, 0.08) !important; }
.bg-light-error { background-color: rgba(255, 82, 82, 0.08) !important; }
.bg-light-purple { background-color: rgba(142, 36, 170, 0.08) !important; }

.loyalty-num {
  line-height: 1.2;
}

.text-secondary-custom {
  color: #64748b !important;
}

/* Chart Cards */
.chart-card {
  border-radius: 12px !important;
  border: 1px solid #e2e8f0 !important;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.05) !important;
  background-color: #ffffff !important;
}

.dark-text {
  color: #1e293b;
}

.contenido-inferior {
  display: flex;
  flex-direction: column;
  min-height: 280px;
}

/* ag-Grid Container styling */
.grid-card-container {
  flex: 1 1 auto;
  min-height: 0;
  border: 1px solid #cbd5e1;
  border-radius: 12px;
  overflow: hidden;
  background: #ffffff;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.05);
}

/* Pagination Custom Styles */
.custom-pagination {
  margin-top: 0 !important;
}

/* Empty State Card */
.empty-state-card {
  background-color: #f8fafc;
  border: 1px dashed #cbd5e1;
  border-radius: 12px;
  max-width: 600px;
  margin: 2rem auto;
}

.max-w-md {
  max-width: 28rem;
}

.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
</style>
